var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.50409V2.49609H5.008V1.50409C5.008 1.22676 5.104 0.992094 5.296 0.800095C5.488 0.597427 5.72267 0.496094 6 0.496094H10C10.2773 0.496094 10.512 0.597427 10.704 0.800095C10.9067 0.992094 11.008 1.22676 11.008 1.50409V2.49609H10V1.50409H6ZM15.008 3.50409C15.2853 3.50409 15.52 3.60009 15.712 3.79209C15.904 3.98409 16 4.21876 16 4.49609V14.4961C16 14.7734 15.904 15.0081 15.712 15.2001C15.52 15.4028 15.2853 15.5041 15.008 15.5041H1.008C0.730667 15.5041 0.490667 15.4028 0.288 15.2001C0.096 15.0081 0 14.7734 0 14.4961V3.50409H15.008ZM15.008 4.49609H1.008V6.49609H15.008V4.49609ZM1.008 14.4961H15.008V7.50409H1.008V14.4961Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSettings);
export default __webpack_public_path__ + "static/media/adminSettings.b2db0467c577f191ee6098e18365c90e.svg";
export { ForwardRef as ReactComponent };